/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { ButtonProps } from '@mui/material';

export const productCardActionButtonProps: ButtonProps = {
	variant: 'outlined',
	sx: { my: 1, p: 0.5 },
};
